import { fetchApi } from '@inmagik/react-crud'
import { useState } from 'react'
import { Button, Form, Modal, Spinner } from 'react-bootstrap'
import 'react-calendar/dist/Calendar.css'
import Select from 'react-select'
import { toast } from 'react-toastify'
import { useAuth } from '../../auth'
import SelectAutoCompleteFilter from '../../components/SelectAutocompleteFilter'
import { API_URL } from '../../constants'
import { useSede } from '../../hooks/sedi'
import { Sede } from '../../types'

interface ModalPropostaProps {
  isOpen: boolean
  toggle: () => void
  cliente: number
  sede?: Sede
}

const TIPO_INTERVENTO_OPTIONS = [
  { value: 'verifica_periodica', label: 'Verifica Periodica' },
  { value: 'rapporto_taratura', label: 'Taratura' },
]

export default function ModalProposta({ isOpen, toggle, cliente, sede: sedeInitial }: ModalPropostaProps) {
  const [idSede, setIdSede] = useState<number | undefined>(sedeInitial?.id)
  const [tipoIntervento, setTipoIntervento] = useState('verifica_periodica')
  const [emailCommerciale, setEmailCommerciale] = useState<string | undefined>(undefined)
  const [loading, setLoading] = useState(false)
  const { tokens } = useAuth()

  const { data: sede } = useSede((idSede ?? '0').toString())

  const emailCommercialeToUse = emailCommerciale || sede?.email_commerciale || sede?.email_referente || ''

  return (
    <Modal show={isOpen} onHide={toggle} centered size="lg" backdropClassName="backdrop-high">
      <Modal.Header className="">
        <Modal.Title>Invia proposta di intervento</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row mt-4">
          <div className="col-md-12">
            <label className="label-m text-body-secondary">Sede a cui inviare la proposta</label>
            <SelectAutoCompleteFilter
              menuPortalTarget={false}
              value={idSede}
              params={{ cliente }}
              onChange={(value: any) => {
                setIdSede(value?.value)
                setEmailCommerciale('')
              }}
              url={`${API_URL}/bilance/sede/options`}
              isMulti={false}
            />
            {sede && sede.id === idSede && (
              <>
                <label className="label-m text-body-secondary mt-3">Email commerciale</label>
                <Form.Control
                  type="email"
                  value={emailCommerciale ?? (sede.email_commerciale || sede.email_referente)}
                  onChange={(e) => setEmailCommerciale(e.target.value)}
                />
              </>
            )}
            <label className="label-m text-body-secondary mt-3">Tipo di intervento</label>
            <Select
              defaultValue={TIPO_INTERVENTO_OPTIONS.find((x) => x.value === tipoIntervento)}
              options={TIPO_INTERVENTO_OPTIONS}
              onChange={(res) => setTipoIntervento(res!.value)}
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-end">
        <Button type="button" onClick={toggle} variant="outline-secondary">
          Annulla
        </Button>
        <Button
          type="button"
          variant="secondary"
          disabled={!idSede || !emailCommercialeToUse || loading}
          className="text-white"
          onClick={() => {
            setLoading(true)
            fetchApi(`${API_URL}/bilance/crea-proposta-da-opportunita/`, {
              method: 'POST',
              headers: {
                Authorization: `Bearer ${tokens?.access}`,
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                sede: idSede,
                tipo_intervento: tipoIntervento,
                email_commerciale: emailCommercialeToUse,
              }),
            })
              .then(() => {
                toggle()
                toast.success('Proposta inviata con successo', {
                  position: 'bottom-right',
                  autoClose: 5000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                })
              })
              .finally(() => {
                setLoading(false)
              })
          }}
        >
          {loading ? <Spinner size="sm" animation="border"></Spinner> : 'Invia'}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
